﻿import controller from '../../../../resources/scripts/_shared/controller';

function expandableListContainerBlock(context) {
  const listLoadingClassName = context.getAttribute('data-loading');
  const triggerClassName = context.getAttribute('data-expand-trigger');
  const panelClassName = context.getAttribute('data-expand-area');
  const allowMultiple = context.hasAttribute('data-allow-multiple');
  const allowToggle = (allowMultiple) ? allowMultiple : context.hasAttribute('data-allow-toggle');
  const triggers = Array.prototype.slice.call(context.querySelectorAll(`.${triggerClassName}`));
  const panels = Array.prototype.slice.call(context.querySelectorAll(`.${panelClassName}`));

  const iconWrappersExists = context.querySelectorAll('.expandable-list-item__heading__icon').length > 0;
  const subHeadersExists = context.querySelectorAll('.expandable-list-item__heading__sub-text').length > 0;

  function init() {
    context.addEventListener('click', function (event) {
      const target = event.target;

      if (listLoadingClassName && context.classList.contains(listLoadingClassName)) {
        event.preventDefault();
        console.log('Loading...');
        return;
      }

      if (target.classList.contains(triggerClassName)) {
        const isExpanded = target.getAttribute('aria-expanded') === 'true';
        const active = context.querySelector('[aria-expanded="true"]');

        if (!allowMultiple && active && active !== target) {
          active.setAttribute('aria-expanded', 'false');
          document.getElementById(active.getAttribute('aria-controls')).setAttribute('hidden', '');

          if (!allowToggle) {
            active.removeAttribute('aria-disabled');
          }
        }

        if (!isExpanded) {
          target.setAttribute('aria-expanded', 'true');
          document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');

          if (!allowToggle) {
            target.setAttribute('aria-disabled', 'true');
          }
        }
        else if (allowToggle && isExpanded) {
          target.setAttribute('aria-expanded', 'false');
          document.getElementById(target.getAttribute('aria-controls')).setAttribute('hidden', '');
        }

        event.preventDefault();
      } else if ((target.tagName === 'A' || target.tagName === 'SPAN') && target.parentElement.querySelector(`.${triggerClassName}`)) {
        target.parentElement.querySelector(`.${triggerClassName}`).click();
        event.preventDefault();
      }
    });

    context.addEventListener('keydown', function (event) {
      const target = event.target;
      const key = event.which.toString();
      const ctrlModifier = (event.ctrlKey && key.match(/33|34/));

      if (target.classList.contains(triggerClassName)) {
        // 38 = Up, 40 = Down
        if (key.match(/38|40/) || ctrlModifier) {
          const index = triggers.indexOf(target);
          const direction = (key.match(/34|40/)) ? 1 : -1;
          const length = triggers.length;
          const newIndex = (index + length + direction) % length;

          triggers[newIndex].focus();

          event.preventDefault();
        }
        else if (key.match(/35|36/)) {
          // 35 = End, 36 = Home
          switch (key) {
            // Go to first accordion
            case '36':
              triggers[0].focus();
              break;
            // Go to last accordion
            case '35':
              triggers[triggers.length - 1].focus();
              break;
          }

          event.preventDefault();
        }
      }
      else if (ctrlModifier) {
        panels.forEach(function (panel, index) {
          if (panel.contains(target)) {
            triggers[index].focus();
            event.preventDefault();
          }
        });
      }
    });

    if (!allowToggle) {
      const expanded = accordion.querySelector('[aria-expanded="true"]');
      if (expanded)
        expanded.setAttribute('aria-disabled', 'true');
    }

		if (!iconWrappersExists && !subHeadersExists) {
      context.classList.add('expandable-list__list--lite');
		}
  }

  return {
    init
  };
}

controller.add('expandable-list-block', expandableListContainerBlock);